import { useHistory } from "react-router-dom";

import { useLogoutUser } from "modules/authentication/infrastructure/useLogoutUser";
import { useLogoutNotification } from "modules/authentication/presentation/useLogoutNotification";

import { useGetFriendlyUrl } from "utils/hooks/useGetFriendlyUrl";

import { ChakraText } from "components/ChakraText";
import { NavigationBarButton } from "components/LayoutComponents";
import { Spinner } from "components/Spinner";
import { useGetThemeColors } from "ChakraTheme";

const LogoutNavigationButton = () => {
  const { friendlyUrl } = useGetFriendlyUrl();
  const logoutUser = useLogoutUser();
  const history = useHistory();
  const {
    showErrorNotification,
    showSuccessNotification,
  } = useLogoutNotification();
  const colors = useGetThemeColors();

  return (
    <NavigationBarButton
      border={`solid 3px ${colors.red[400]}`}
      onClick={async () => {
        try {
          await logoutUser.mutateAsync();
          history.push(`/e-rezerwacja/${friendlyUrl}`);
          showSuccessNotification();
        } catch {
          showErrorNotification();
        }
      }}
      id="user-navigation-logout-btn"
    >
      <ChakraText>
        {logoutUser.isLoading ? <Spinner mt={1} size="md" /> : "Wyloguj"}
      </ChakraText>
    </NavigationBarButton>
  );
};

export { LogoutNavigationButton };
